import React, { useRef, useState } from "react";
import { useFormik } from 'formik';
import { Link } from "react-router-dom";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import ReCAPTCHA from 'react-google-recaptcha'

const SingUp = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const [isComplete, setIsComplete] = useState(false);
    const [margin, setMargin] = useState({
        marginLeft: 0, marginRight: 0
    });
    const stepRef = useRef([])

    const NextStep = () => {
        setCurrentStep(prevStep => {
            if (prevStep === configStep.length) {
                setIsComplete(true)
                return prevStep
            } else {
                return prevStep + 1
            }
        })
    }
    const calculateProgessBarWidth = () => {
        return ((currentStep - 1) / (configStep.length - 1) * 100)
    }
    // useEffect(() => {
    //     setMargin({
    //         marginLeft: stepRef.current[0].offsetWidth / 2,
    //         marginRight: stepRef.current[configStep.length - 1].offsetWidth / 2
    //     })
    // }, [stepRef])

    const ActiveComponent = () => {
        const CurrentComponent = configStep[currentStep - 1]?.Component;
        return CurrentComponent ? <CurrentComponent NextStep={NextStep} /> : null;
    };


    const configStep = [
        {
            Component: () => <LoginForm  NextStep={NextStep} />
        },
        {
            Component: () => <DetailsForm  NextStep={NextStep} />
        },
        {
            Component: () => <AddressFrom  NextStep={NextStep} />
        },
        {
            Component: () => <UserTypeForm  NextStep={NextStep} />
        },
        {
            Component: () => <VerifyOtp NextStep={NextStep} />
        },
    ]

    return (
        <div className="container-fluid p-0">
            {/* Top Header */}
            <div className='topheadercontainer login-topheader'>
                <div className='toheader topheaderleftdiv'>
                    <img src="img/email.png" alt='email' className='top-content-lg' />
                    <h6 className='topheader-title m-0 top-content-lg'>citizenhelpdesk@mpurban.gov.in</h6>
                    <h6 className='topheader-title m-0 top-content'>Government OF MADHYA PRADESH</h6>
                </div>
                <div className='toheader topheaderleftdiv'>
                    <img src="img/social-icons.png" alt='facebook' />
                    <img src="img/social-icons-one.png" alt='facebook' />
                    <img src="img/social-icons-two.png" alt='facebook' />
                    <img src="img/email.png" alt='email' />
                </div>
            </div>
            {/* Main Content */}
            <div className="row gx-0">
                <div className="col-xl-7 col-lg-7 col-md-7 co-12">
                    <div className="login-left-content">
                    <div className="ui-content">
                            <div className="row">
                                <div className="col-md-12">
                                    <h6 className="login-lefttitle m-0">Welcome to Urban</h6>
                                    <h6 className="login-lefttitle m-0">Data Analytics</h6>
                                    <h3 className="login-insights m-0">Urban Insights at Your Fingertips</h3>
                                    <p className="loginpara m-0">Transforming Data into Decisions. Discover your city like <br /> never before.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-5 col-lg-5 col-md-5 co-12">
                    <div className="login-right">
                        <div>
                            <div className="stepper">
                                {configStep.map((step, index) => {
                                    return (
                                        <div key={index}
                                            ref={(el) => (stepRef.current[index] = el)}
                                            className={`step ${currentStep > index + 1 || isComplete ? 'complete' : ""} 
                                             ${currentStep === index + 1 ? 'active activestep' : ''}`
                                            }>
                                            <div className="step-number">
                                                {currentStep === index + 1 ? (
                                                    <span className="insidecircle"></span>
                                                ) : currentStep > index + 1 ? (
                                                    <span className="checkmark">✔</span>
                                                ) : (
                                                    <span className="insidecircle"></span>
                                                )}
                                            </div>
                                        </div>
                                    )
                                })}
                                <div className="progress-bar" style={{
                                    width: `calc(100% - ${margin.marginLeft + margin.marginRight}px)`,
                                    marginLeft: margin.marginLeft,
                                    marginRight: margin.marginRight,
                                    height: "3px"
                                }}>
                                    <div className="progress" style={{ width: `${calculateProgessBarWidth()}%` }}></div>
                                </div>
                            </div>
                        </div>
                        <Link to='/' style={{textDecoration:'none'}}>
                        <div className="loginlogodiv">
                            <img src="img/mplogo.png" alt="Logo" width="53px" height="53px" />
                            <p className="m-0 govt-title">Directorate, Urban Administration & Development Government of Madhya Pradesh</p>
                        </div>
                        </Link>

                        <h1 className="logintitle">Create account</h1>
                        <p className="login-pera">Vorem ipsum dolor sit amet, consectetur adipiscing elit.</p>

                        <ActiveComponent configStep={configStep} />

                        {/* {!isComplete && (
                            <button className="btn" onClick={() => NextStep()}>{currentStep === configStep.length ? "Finish" : "Next"}</button>
                        )} */}

                        <p className="login-link mb-0">Already have an account? <Link to="/login">Login now</Link></p>
                    </div>
                </div>
            </div>
            <div className='login-bottom'>
                <img src="img/Netlink-logo.svg" alt="Netlink" width="16px" height="16px" className="mx-2" />
                <h6 className='topheader-title m-0'>Designed,Developed & Maintained by Netlink Software Pvt Ltd </h6>
            </div>
        </div>
    );
};

const LoginForm = ({ NextStep }) => {
    const [currentPass, setCurrentPass] = useState(true);
    const [confirmPass, setConFirmPass] = useState(true);
    const handleLoginSubmit = (values) => {
        NextStep()
        console.log("Login form submitted:", values);

    };
    const handlePassword = () => {
        setCurrentPass(!currentPass);
    };
    const handleConfirmPassword = () => {
        setConFirmPass(!confirmPass);
    };
    const formikLogin = useFormik({
        initialValues: {
            email: '',
            password: '',
            confirmPassword: '',
        },
        validate: (values) => {
            const errors = {};
            if (!values.email) {
                errors.email = 'Email is required';
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                errors.email = 'Invalid email address';
            }
            if (!values.password) {
                errors.password = 'Password is required';
            }
            if (values.password !== values.confirmPassword) {
                errors.confirmPassword = 'Passwords do not match';
            }
            return errors;
        },
        onSubmit: (values) => {
            handleLoginSubmit()
        },
    });
    return (
        <form onSubmit={formikLogin.handleSubmit} className="loginform">
            <div>
                <input
                    id="email"
                    name="email"
                    type="email"
                    className='form-control'
                    onChange={formikLogin.handleChange}
                    value={formikLogin.values.email}
                    placeholder='Email address'
                />
                {formikLogin.errors.email && <div className="error-message">{formikLogin.errors.email}</div>}
            </div>

            <div className="position-relative">
                <input
                    id="password"
                    name="password"
                    type={currentPass ? "password" : 'text'}
                    className='form-control'
                    onChange={formikLogin.handleChange}
                    placeholder='Create Password'
                    value={formikLogin.values.password}
                />
                <div className='eyediv' onClick={handlePassword}>
                    {currentPass ? <FaEye /> : <FaEyeSlash />}
                </div>
                {formikLogin.errors.password && <div className="error-message">{formikLogin.errors.password}</div>}
            </div>

            <div className="position-relative">
                <input
                    id="confirmPassword"
                    name="confirmPassword"
                    type={confirmPass ? "password" : 'text'}
                    className='form-control'
                    onChange={formikLogin.handleChange}
                    placeholder='Confirm Password'
                    value={formikLogin.values.confirmPassword}
                />
                 <div className='eyediv' onClick={handleConfirmPassword}>
                    {confirmPass ? <FaEye /> : <FaEyeSlash />}
                </div>
                {formikLogin.errors.confirmPassword && <div className="error-message">{formikLogin.errors.confirmPassword}</div>}
            </div>

            <button type="submit" className="btn-login">Submit</button>
        </form>
    )
}

const DetailsForm = ({ NextStep }) => {
    const handleDetailsSubmit = (values) => {
        NextStep()
        console.log("Personal details form submitted:", values);
    };
    const formikDetails = useFormik({
        initialValues: {
            firstname: '',
            lastname: '',
            designation: '',
            department: '',
            phone: '',
            pannumber: '',
        },
        validate: (values) => {
            const errors = {};
            if (!values.firstname) errors.firstname = 'First name is required';
            if (!values.lastname) errors.lastname = 'Last name is required';
            if (!values.phone) errors.phone = 'Phone number is required';
            if (!values.pannumber) errors.pannumber = 'PAN number is required';
            return errors;
        },
        onSubmit: (values) => {
            handleDetailsSubmit()
        },
    });
    return (
        <>
            {/* Personal Details Form */}
            <form onSubmit={formikDetails.handleSubmit} className="loginform">
                <div className="row">
                    <div className="col-md-6">
                        <input
                            id="firstname"
                            name="firstname"
                            type="text"
                            className='form-control'
                            onChange={formikDetails.handleChange}
                            value={formikDetails.values.firstname}
                            placeholder='First name'
                        />
                        {formikDetails.errors.firstname && <div className="error-message">{formikDetails.errors.firstname}</div>}
                    </div>

                    <div className="col-md-6">
                        <input
                            id="lastname"
                            name="lastname"
                            type="text"
                            className='form-control'
                            onChange={formikDetails.handleChange}
                            value={formikDetails.values.lastname}
                            placeholder='Last name'
                        />
                        {formikDetails.errors.lastname && <div className="error-message">{formikDetails.errors.lastname}</div>}
                    </div>

                    {/* Additional Fields */}
                    <div className="col-md-6">
                        <input
                            id="designation"
                            name="designation"
                            type="text"
                            className='form-control'
                            onChange={formikDetails.handleChange}
                            value={formikDetails.values.designation}
                            placeholder='Designation'
                        />
                    </div>

                    <div className="col-md-6">
                        <input
                            id="department"
                            name="department"
                            type="text"
                            className='form-control'
                            onChange={formikDetails.handleChange}
                            value={formikDetails.values.department}
                            placeholder='Department'
                        />
                    </div>

                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-lg-2 col-md-3 col-3">
                                <div className="indiaflag">
                                    <img src="img/india.svg" alt="India" />
                                </div>
                            </div>
                            <div className="col-lg-10 col-md-9 col-9">
                                <input
                                    id="phone"
                                    name="phone"
                                    type="number"
                                    className='form-control'
                                    onChange={formikDetails.handleChange}
                                    value={formikDetails.values.phone}
                                    placeholder='Phone number'
                                />
                                {formikDetails.errors.phone && <div className="error-message">{formikDetails.errors.phone}</div>}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <input
                            id="pannumber"
                            name="pannumber"
                            type="text"
                            className='form-control'
                            onChange={formikDetails.handleChange}
                            value={formikDetails.values.pannumber}
                            placeholder='PAN Number'
                        />
                        {formikDetails.errors.pannumber && <div className="error-message">{formikDetails.errors.pannumber}</div>}
                    </div>
                </div>

                <button type="submit" className="btn-login">Submit</button>
            </form>
        </>
    )
}

const AddressFrom = ({ NextStep }) => {
    const handleAddressSubmit = (values) => {
        NextStep()
        console.log("Address details form submitted:", values);
    };
    const formikAddress = useFormik({
        initialValues: {
            address: '',
            city: '',
            district: '',
            state: '',
            pincode: '',
            country: '',
        },
        validate: (values) => {
            const errors = {};
            if (!values.address) errors.address = 'Address is required';
            if (!values.city) errors.city = 'City is required';
            if (!values.state) errors.state = 'State is required';
            if (!values.pincode) errors.pincode = 'Pincode is required';
            if (!values.country) errors.country = 'Country is required';
            return errors;
        },
        onSubmit: (values) => {
            handleAddressSubmit()
        },
    });

    return (
        <form onSubmit={formikAddress.handleSubmit} className="loginform">
            <div className="row">
                <div className="col-md-12">
                    <input
                        id="address"
                        name="address"
                        type="text"
                        className="form-control"
                        onChange={formikAddress.handleChange}
                        value={formikAddress.values.address}
                        placeholder="Address"
                    />
                    {formikAddress.errors.address && (
                        <div className="error-message">{formikAddress.errors.address}</div>
                    )}
                </div>

                <div className="col-md-6">
                    <input
                        id="city"
                        name="city"
                        type="text"
                        className="form-control"
                        onChange={formikAddress.handleChange}
                        value={formikAddress.values.city}
                        placeholder="City"
                    />
                    {formikAddress.errors.city && (
                        <div className="error-message">{formikAddress.errors.city}</div>
                    )}
                </div>

                <div className="col-md-6">
                    <input
                        id="district"
                        name="district"
                        type="text"
                        className="form-control"
                        onChange={formikAddress.handleChange}
                        value={formikAddress.values.district}
                        placeholder="District"
                    />
                    {formikAddress.errors.district && (
                        <div className="error-message">{formikAddress.errors.district}</div>
                    )}
                </div>

                <div className="col-md-6">
                    <input
                        id="state"
                        name="state"
                        type="text"
                        className="form-control"
                        onChange={formikAddress.handleChange}
                        value={formikAddress.values.state}
                        placeholder="State"
                    />
                    {formikAddress.errors.state && (
                        <div className="error-message">{formikAddress.errors.state}</div>
                    )}
                </div>

                <div className="col-md-6">
                    <input
                        id="pincode"
                        name="pincode"
                        type="text"
                        className="form-control"
                        onChange={formikAddress.handleChange}
                        value={formikAddress.values.pincode}
                        placeholder="Pincode"
                    />
                    {formikAddress.errors.pincode && (
                        <div className="error-message">{formikAddress.errors.pincode}</div>
                    )}
                </div>

                <div className="col-md-12">
                    <input
                        id="country"
                        name="country"
                        type="text"
                        className="form-control"
                        onChange={formikAddress.handleChange}
                        value={formikAddress.values.country}
                        placeholder="Country"
                    />
                    {formikAddress.errors.country && (
                        <div className="error-message">{formikAddress.errors.country}</div>
                    )}
                </div>
            </div>

            <button type="submit" className="btn-login">Submit</button>
        </form>
    )
}

const UserTypeForm = ({ NextStep }) => {
    const handleUserTypeSubmit = (values) => {
        NextStep()
        console.log("User type form submitted:", values);
    };

    const formikUserType = useFormik({
        initialValues: {
            usertype: '',
            ulbname: '',
            zonename: '',
            wardname: '',
        },
        validate: (values) => {
            const errors = {};
            if (!values.usertype) errors.usertype = 'User type is required';
            if (!values.ulbname) errors.ulbname = 'ULB name is required';
            if (!values.zonename) errors.zonename = 'Zone name is required';
            if (!values.wardname) errors.wardname = 'Ward name is required';
            return errors;
        },
        onSubmit: handleUserTypeSubmit,
    });
    return (
        <form onSubmit={formikUserType.handleSubmit} className="loginform">
            <div className="row">
                <div className="col-md-12">
                    <input
                        id="usertype"
                        name="usertype"
                        type="text"
                        className="form-control"
                        onChange={formikUserType.handleChange}
                        value={formikUserType.values.usertype}
                        placeholder="User type"
                    />
                    {formikUserType.errors.usertype && (
                        <div className="error-message">{formikUserType.errors.usertype}</div>
                    )}
                </div>

                <div className="col-md-6">
                    <input
                        id="ulbname"
                        name="ulbname"
                        type="text"
                        className="form-control"
                        onChange={formikUserType.handleChange}
                        value={formikUserType.values.ulbname}
                        placeholder="ULB name"
                    />
                    {formikUserType.errors.ulbname && (
                        <div className="error-message">{formikUserType.errors.ulbname}</div>
                    )}
                </div>

                <div className="col-md-6">
                    <input
                        id="zonename"
                        name="zonename"
                        type="text"
                        className="form-control"
                        onChange={formikUserType.handleChange}
                        value={formikUserType.values.zonename}
                        placeholder="Zone name"
                    />
                    {formikUserType.errors.zonename && (
                        <div className="error-message">{formikUserType.errors.zonename}</div>
                    )}
                </div>

                <div className="col-md-12">
                    <input
                        id="wardname"
                        name="wardname"
                        type="text"
                        className="form-control"
                        onChange={formikUserType.handleChange}
                        value={formikUserType.values.wardname}
                        placeholder="Ward name"
                    />
                    {formikUserType.errors.wardname && (
                        <div className="error-message">{formikUserType.errors.wardname}</div>
                    )}
                </div>
            </div>

            <div className="recaptcha-container" style={{ transform: "scale(0.85)", transformOrigin: "0 0" }}>
                <ReCAPTCHA sitekey="6Lel4Z4UAAAAAOa8LO1Q9mqKRUiMYl_00o5mXJrR" className="mt-3 g-recaptcha" />
            </div>

            <button type="submit" className="btn-login">Submit</button>
        </form>
    )
}

const VerifyOtp = () => {
    const inputRefs = useRef([]);
    const [values, setValues] = useState(["", "", "", ""]);
  
    const handleKeyUp = (event, index) => {
      if (event.code === "Backspace" && !values[index] && index > 0) {
        inputRefs.current[index - 1].focus();
      } else if (values[index] && index < values.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    };
  
    const handleChange = (event, index) => {
      let val = event.target.value;
      if (val.length > 1) {
        val = val[val.length - 1]; // Keep only the last digit entered
      }
  
      const newValues = [...values];
      newValues[index] = val;
      setValues(newValues);
  
      if (val && index < values.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    };
  
    const handlePaste = (event, index) => {
      event.preventDefault();
      const pastedData = event.clipboardData.getData("text").split("");
      const newValues = [...values];
  
      for (let i = index; i < newValues.length; i++) {
        if (pastedData.length) {
          newValues[i] = pastedData.shift();
        }
      }
      setValues(newValues);
    };
  
    return (
      <div >
        <div className="d-flex justify-content-between verifydiv">
        {values.map((val, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="number"
            min="0"
            max="9"
            step="1"
            value={val}
            onChange={(e) => handleChange(e, index)}
            onKeyUp={(e) => handleKeyUp(e, index)}
            onPaste={(e) => handlePaste(e, index)}
            aria-label={`Digit ${index + 1}`}
            className="otp-input"
          />
        ))}
        </div>
        <button type="submit" className="btn-resendotp">Resend OTP</button>
        <button type="submit" className="btn-login">Verify OTP</button>
      </div>
    );
  };
  
export default SingUp;
